import request from '@/utils/http';
// 查询列表数据
export const getList = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/getEtTaskByContractNo`,
        method: 'post',
        data
    });
};

// 设备绑定
export const bundDevice = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/bundDevice`,
        method: 'post',
        data
    });
};

// 设备回收
export const recallDevice = (data) => {
    return request({
        url: `/api-srm-web/order/ltms/recallDevice`,
        method: 'post',
        data
    });
};